import { useMemo } from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "@/store";
import { TaxWorkflowFilterState } from "../types";

export const useFilterState = (): TaxWorkflowFilterState => {
  const selectFilter = (state: ApplicationState) => state.taxWorkflowFilter;

  const filterState = useSelector(selectFilter);

  return useMemo(() => filterState, [filterState]);
};
